import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DialogService, ToastrService} from '@kpmg-tax/ui';

import {SessionService} from '../../shared/session-service/session.service';
import {MasterActivities} from '../../shared/models/master-activity/master-activities.model';
import {API_URL} from '../../shared/constants/apiurl-constants';

@Injectable({
  providedIn: 'root',
})
export class MasterActivitiesService {
  activitiesTableRefresh = new BehaviorSubject({});
  refreshActivities = this.activitiesTableRefresh.asObservable();

  constructor(
    public sessionService: SessionService,
    public dialogService: DialogService,
    public toastrService: ToastrService,
  ) {}

  refreshTable() {
    this.activitiesTableRefresh.next(true);
  }

  GetActivityGroup() {
    return this.sessionService.apiUrlGet(
      API_URL.MASTERACTIVITY.GETMASTERACTIVITYGROUP,
    );
  }

  deleteRowActivity = (row: MasterActivities) => {
    let id = row.activityID;
    this.sessionService
      .apiUrlGet(API_URL.MASTERACTIVITY.DELETEACTIVITY + '?id=' + id)
      .subscribe(
        data => {
          this.refreshTable();
          // If request is successful, Refresh data table on page
          this.toastrService.setSuccessMessage(
            'Activity: ' + row.name + ' deleted successfully.',
          );
        },
        error => {
          // If request fails,  give an error.
          this.toastrService.setErrorMessage(
            'Unable to delete activity: '  + id + '. Please contact the application support team by clicking the envelope icon on the top right corner of your screen.',
          );
        },
      );
  };

  getMasterActivities() {
    return this.sessionService.apiUrlGet(API_URL.MASTERACTIVITY.GETMASTERLIST);
  }
}
